import React from "react";
import { PasswordResetBody } from "tsi-common-react/src/apps/customer-account/PasswordResetBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetBody {...props} />
    </PageSkeleton>
);
